<template>
  <v-dialog fullscreen persistent v-model="dialog">
    <v-card>
      <v-toolbar flat color="primary">
        <v-toolbar-title>
          <h3>Write blog</h3>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn flat @click="$emit('input', '')">Reset</v-btn>
          <v-btn flat @click="handleOK()">OK</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>
        <v-card-text>
          <v-layout row wrap>
            <v-flex sm6 xs12 class="mt-3">
            
              <div class="input-layout">
                <quill-editor
                  class="editor"
                  ref="myTextEditor"
                  :value="value"
                  :options="editorOption"
                  @change="onEditorChange"
                />
              </div>
            </v-flex>
            <v-flex sm6 xs12 class="mt-3">
             
              <div class="output-layout">
                <div class="output">
                  <div>
                    <div
                      class="mt-3 ml-3"
                      v-if="value == ''"
                      style="color:grey;"
                    >Text example is here...</div>
                    <div class="ql-editor content-html" v-html="value" v-else></div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import dedent from "dedent";
import hljs from "highlight.js";
import debounce from "lodash/debounce";
import { quillEditor } from "vue-quill-editor";
// highlight.js style
import "highlight.js/styles/tomorrow.css";
// import theme style
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  props: ["dialog","value"],
  components: {
    quillEditor
  },
  data() {
    return {
      blogTitle: "",
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["image", "link", "video"]
          ],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      },
      image: null
    };
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
      }
    }
  },
  methods: {
    onEditorChange: debounce(function(value) {
      this.$emit('input', value.html)
    }, 466),
    handleOK() {
      this.$emit("closeDialog");
      this.$emit('save');
      
    }
  },
  computed: {
    editor() {
      return this.$refs.myTextEditor.quill;
    },
    contentCode() {
      return hljs.highlightAuto(value).value;
    }
  },
  mounted() {
    console.log("this is Quill instance:", this.editor);
  }
};
</script>

<style>
.content-html img {
  width: 100%;
  height: 100%;
}
</style>

<style scoped>
.proto-image {
  background-color: grey;
  width: 100%;
  height: 150px;
}

.layout-image {
  display: flex;
  justify-content: center;
}

.layout-title {
  display: flex;
  padding: 20px 20px 20px 0px;
}

.layout-title span {
  font-size: 22px;
  font-weight: 600;
  word-break: break-all;
}

.editor {
  max-width: 375px;
  width:60%;
  min-width: 320px;
  height: 55vh;
}
.output {
  max-width: 375px;
  width:60%;
  min-width: 320px;
  height: 70vh;
  margin: 0;
  border: 1px solid #ccc;
  overflow-y: auto;
  resize: vertical;
}

.output-layout {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.input-layout {
  height: 75vh;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.input-title-layout {
  display: flex;
  align-items: center;
}
</style>
